<template>
  <div>
    <div class="bodyWrap">
      <header>
        <div class="headTop">
          <div class="topBox">
            <div class="headLeft fl">
              <span>时间：2021年3月31日</span>
              <span>星期三</span>
            </div>
            <div class="headRig fr">
              <router-link  to="/login" tag="span">登录</router-link>
              <router-link to="/register" tag="span">注册</router-link>
            </div>
          </div>
        </div>
        <div class="headBottom">
          <div class="bottomBox">
            <div class="botLeft fl">
              <img src="../../assets/img/show/logo.png" alt="">
            </div>
            <div class="botdRig fr">
              <ul class="fl headUl">
                <li>资源管理</li>
                <li>统计分析</li>
                <li>返回信息网</li>
              </ul>
              <div class="fr headSearch">
                <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="main">
        <div class="mainBox">
          <div class="box1">
            <span>用户登录</span>
            <span class="register fr">立即注册</span>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <div>
              <img src="../../assets/img/show/loIco2.png" alt="">
              <input type="text" placeholder="邮箱/用户名/已验证手机号">
            </div>
            <div>
              <img src="../../assets/img/show/loIco3.png" alt="">
              <input type="text" placeholder="请输入密码">
            </div>
            <dd class="fr">
              <a href=##>忘记密码？</a>
              <el-checkbox label="记住我" name="type"></el-checkbox>
            </dd>
            <button class="loginBtn">登 录</button>
          </el-form>
        </div>
      </div>

      <footer>
        <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      input:'',
      ruleForm: {
        type: [],
      },
    };
  },
  methods: {


  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
.bodyWrap{
  width:100%;
  margin:0 auto;
  background: #eeeeee;
}
.loginBtn{
  margin-top: 33px;
  height: 42px;
  background: #f8a106;
  border: none;
  font-size: 15px;
  color: #fff;
  width: 100%;
}
form dd a{
  font-size: 14px;
  margin-right: 25px;
  color: #027248;
  text-decoration: underline;
}
form label{
  color:#333333;
  font-size: 14px;
}
form label input{
  width: 13px;
  height: 13px;
}
.box1 span{
  color: #f8a106;
  font-size: 15px;
}
form{
  margin-top: 36px;
}
form div{
  width: 342px;
  height: 43px;
  border: 1px solid #e8e8e8;
  line-height: 43px;
  margin-bottom: 26px;
}
form div img{
  padding: 0 25px 0 15px;
  height: 24px;
  width: 22px;
  margin-top: 9.5px;
  display: inline-block;
}
::-webkit-input-placeholder {
  color: #bfbfbf;
  font-size: 15px;
}
form div input{
  color: #bfbfbf;
  font-size: 15px;
  height: auto;
  vertical-align: top;
  border:none;
  width: 70%;
  line-height: 43px;
}
.register{
  background: url("../../assets/img/show/orange.png") no-repeat left center;
  padding-left: 30px;
  display: inline-block;
}
.main{
  background: url("../../assets/img/show/loginBj.png") no-repeat top center;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: fixed;
  top:130px;
  left: 0;
  overflow: hidden;

}

.mainBox{
  position: absolute;
  top: 50%;
  right: 11%;  border-top: 7px solid #027248;
  width: 350px;
  height: 290px;
  margin: -245px 0 0 -250px;
  background: #fff;
  text-align: left;
  z-index: 9001;
  padding:35px 55px;
}
footer{
  height: 84px;
  line-height: 84px;
  background: #4a4e53;
  margin-top: 66px;
  text-align: center;
}
footer p{
  font-size: 14px;
  color: #fff;
}
.bottomBox{
  width: 1200px;
  margin: 0 auto;
}
.headBottom{
  background:#fff;
  height: 100px;

}
.headSearch{
  height: 40px;
  margin-top: 30px;
  position: relative;
}
.headSearch span{
  background: #02874a;
  position: absolute;
  right: -45px;
  top: 0;
  height: 38px;
  width: 51px;
  border: 1px solid #02874a;
  border-top-right-radius: 5px;
  border-left: 0;
  border-bottom-right-radius: 5px;
}
.headSearch span img{
  margin: 0 auto;
  text-align: center;
  display: block;
  margin-top: 7px;
  height: 24px;
}
.botLeft img{
  width: 489px;
  height: 42px;
  display: block;
  margin-top:29px;
}
.headUl li{
  font-size: 16px;
  color: #333333;
  display: inline-block;
  float: left;
  margin-right: 40px;
  line-height: 100px;
}
.topBox{
  width: 1200px;
  margin: 0 auto;
}
.headTop{
  background:#f1f1f1;
  height: 30px;
  line-height: 28px;
}
.el-input__inner{
  border: 1px solid #02874a !important;
  font-size: 14px;
}
.headLeft span{
  font-size: 12px;
  color: #666666;
  display: inline-block;
  margin-right: 30px;
}
.headRig span{
  font-size: 12px;
  color: #666666;
  margin-left: 30px;
  display: inline-block;
}
</style>
